module.exports = __webpack_public_path__ + "img/florecita.e903fb4a.svg";